<template>
  <v-dialog 
    max-width="300" 
    v-model="alert"
  >
    <v-card>
      <v-card-title class="justify-center">
        <p :class="`text-h5 font-weight-bold ${type}`">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text>
        <p class="text-h6 black--text text-center">
          {{ message }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    alert: Boolean,
    type: String,
    title: String,
    message: String,
  }
};
</script>